import styled from '@emotion/styled';
import { rem } from '@utils';

const Root = styled.article`
  background: ${({ theme }) => theme.palette.common.white};
  border: ${rem(1)} solid ${({ theme }) => theme.palette.grey['200']};
  border-radius: ${rem(12)};
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
  padding: ${rem(16)};
  width: 100%;
`;

const Title = styled.h4`
  color: ${({ theme }) => theme.palette.common.black};
  font-size: ${rem(16)};
  font-weight: 600;
  line-height: ${rem(24)};
  margin: 0;
`;

const Body = styled.p`
  color: ${({ theme }) => theme.palette.grey['600']};
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(20)};
  margin: 0;
`;

const Chart = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export default {
  Root,
  Title,
  Body,
  Chart
};
